import React, { useState, Fragment } from 'react';
import PropTypes from 'prop-types';

import BoxedCustomControl from '../BoxedCustomControl';
import useAlbumGreenScreenUploadCheck from './hooks/useAlbumGreenScreenUploadCheck';
import useOpenAlert from '../../../hooks/useOpenAlert';
import { getErrorString } from '../../../util/normalize-errors';
import Button from '../Button';
import Spinner from '../Spinner';

const propTypes = {
  albumId: PropTypes.string,
  hasTeamTag: PropTypes.bool,
  onSuccess: PropTypes.func,
  onRequestClose: PropTypes.func,
};

const AlbumGreenScreenUploadCheck = ({
  albumId,
  hasTeamTag,
  onSuccess,
  onRequestClose,
}) => {
  const openAlert = useOpenAlert();
  const [submitting, setSubmitting] = useState(false);
  const [isGreenScreen, setIsGreenScreen] = useState(null);
  const [includesGroupPhoto, setIncludesGroupPhoto] = useState(null);

  const {
    loading,
    onAlbumUpdate,
    includeGreenScreenCheck,
  } = useAlbumGreenScreenUploadCheck({ albumId });

  const onSubmit = async () => {
    if (submitting) {
      return;
    }

    try {
      if (includeGreenScreenCheck) {
        await onAlbumUpdate({
          id: albumId,
          green_screen_enabled: !!isGreenScreen,
        });
      }
      onSuccess?.({ includesGroupPhoto });
      onRequestClose();
    } catch (e) {
      openAlert(getErrorString(e));
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) {
    return (
      <div className="p-6 m-6 text-center">
        <Spinner />
      </div>
    );
  }

  return (
    <Fragment>
      <h3 className="mb-5 text-center">Before you upload...</h3>
      {includeGreenScreenCheck && (
        <Fragment>
          <h4>Is this a green screen upload?</h4>
          <div className="create-step-two-column-grid create-step-two-column-grid-sm mb-2">
            <BoxedCustomControl
              id="green_screen"
              type="checkbox"
              label="Yes"
              onChange={() => setIsGreenScreen(true)}
              checked={isGreenScreen === true}
              className="text-center pt-2"
              boxStyle="secondary"
            />
            <BoxedCustomControl
              id="no_green_screen"
              type="checkbox"
              label="No"
              onChange={() => setIsGreenScreen(false)}
              checked={isGreenScreen === false}
              className="text-center pt-2"
              boxStyle="secondary"
            />
          </div>
        </Fragment>
      )}
      <h4>Does your upload contain one or more group photos?</h4>
      <div className="create-step-two-column-grid create-step-two-column-grid-sm mb-2">
        <BoxedCustomControl
          id="contains_group_photo"
          type="checkbox"
          label="Yes"
          onChange={() => setIncludesGroupPhoto(true)}
          checked={includesGroupPhoto === true}
          className="text-center pt-2"
          boxStyle="secondary"
        />
        <BoxedCustomControl
          id="doesnt_contains_group_photo"
          type="checkbox"
          label="No"
          onChange={() => setIncludesGroupPhoto(false)}
          checked={includesGroupPhoto === false}
          className="text-center pt-2"
          boxStyle="secondary"
        />
      </div>
      <div className="text-center mt-3">
        <Button
          onClick={() => onSubmit()}
          disabled={
            (hasTeamTag && includesGroupPhoto === null) ||
            (includeGreenScreenCheck && isGreenScreen === null)
          }
        >
          {submitting ? 'Saving...' : 'Continue'}
        </Button>
      </div>
    </Fragment>
  );
};

AlbumGreenScreenUploadCheck.propTypes = propTypes;

export default AlbumGreenScreenUploadCheck;
